import React from 'react'
import jsPDF from 'jspdf';
import { useRef } from 'react';
import { useState, useEffect, useCallback } from "react";

export default function Playerspdf() {
    const canvasRef = useRef(null);

    useEffect(() => {

    }, []); // Run the effect only once on mount
    const convertToBase64 = (imageUrl) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.crossOrigin = 'Anonymous';
          img.src = imageUrl;
    
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
    
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
    
            const base64Data = canvas.toDataURL('image/png');
            resolve(base64Data);
            console.log(base64Data)
          };
        });
      };
    const imageUrl = 'https://mscspa.s3.amazonaws.com/playersphoto/230510124585589.jpg';
    convertToBase64(imageUrl);
    return (
        <>
            {/* <div>
                <img id="sourceImage" src="https://mscspa.s3.amazonaws.com/playersphoto/230510124585589.jpg" alt="Your Image" style={{ display: 'none' }} />
                <canvas ref={(ref) => { if (ref) { canvasRef } }} style={{ display: 'none' }}></canvas>
            </div> */}
            <button>Generate</button>
        </>
    )
}
